import * as React from 'react';
const SvgSort = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M8.774 14.084a.53.53 0 0 1-.386-.155.52.52 0 0 1-.156-.383q0-.228.156-.387A.52.52 0 0 1 8.774 13h2.444a.526.526 0 0 1 .542.538.53.53 0 0 1-.156.387.52.52 0 0 1-.386.159zm-2.896-3.542a.53.53 0 0 1-.386-.155.52.52 0 0 1-.155-.383q0-.227.155-.387a.52.52 0 0 1 .386-.158h8.236a.527.527 0 0 1 .541.537.53.53 0 0 1-.155.387.52.52 0 0 1-.386.159zM3.958 7a.53.53 0 0 1-.385-.154.52.52 0 0 1-.156-.383q0-.23.156-.387a.52.52 0 0 1 .385-.159h12.084q.23 0 .386.155.156.154.155.382a.53.53 0 0 1-.155.388.52.52 0 0 1-.386.158z'
            />
        </g>
    </svg>
);
export default SvgSort;
